import { render, staticRenderFns } from "./StudentRequestHistory.vue?vue&type=template&id=12477d00"
import script from "./StudentRequestHistory.vue?vue&type=script&lang=js"
export * from "./StudentRequestHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports